// ═══════════════════════════════════════════════════════════════════
//  composants/LineChart.js
//  LineChart
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";

export function LineChart({ series, labels, height = 180, area }) {
  const W = 600, H = height, padL = 32, padB = 22, padT = 10, padR = 8, n = labels.length;
  const max = Math.max(1, ...series.flatMap((s) => s.values));
  const x = (i) => padL + (i / Math.max(1, n - 1)) * (W - padL - padR);
  const y = (v) => padT + (1 - v / max) * (H - padT - padB);
  const ticks = [0, Math.round(max / 2), max].filter((v, i, a) => a.indexOf(v) === i);
  const tickIdx = [0, Math.floor(n / 2), n - 1].filter((v, i, a) => a.indexOf(v) === i);
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} preserveAspectRatio="none" style={{ display: "block" }}>
      {ticks.map((tk, i) => (<g key={`t${i}`}><line x1={padL} y1={y(tk)} x2={W - padR} y2={y(tk)} stroke={THEME.border} strokeWidth="1" vectorEffect="non-scaling-stroke" /><text x={4} y={y(tk) + 3} fill={THEME.textDim} fontSize="9">{tk}</text></g>))}
      {tickIdx.map((i) => (<text key={`x${i}`} x={x(i)} y={H - 6} fill={THEME.textDim} fontSize="9" textAnchor="middle">{labels[i] ? labels[i].slice(8, 10) + "/" + labels[i].slice(5, 7) : ""}</text>))}
      {series.map((s, si) => {
        const line = s.values.map((v, i) => `${x(i)},${y(v)}`).join(" "); const id = "lc" + si + s.color.replace("#", "");
        return (<g key={`s${si}`}>{area && series.length === 1 && [<defs key="d"><linearGradient id={id} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={s.color} stopOpacity="0.3" /><stop offset="100%" stopColor={s.color} stopOpacity="0" /></linearGradient></defs>, <polygon key="p" points={`${padL},${H - padB} ${line} ${W - padR},${H - padB}`} fill={`url(#${id})`} />]}<polyline points={line} fill="none" stroke={s.color} strokeWidth="2" vectorEffect="non-scaling-stroke" /></g>);
      })}
    </svg>
  );
}
